import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getMaturityFramework } from "@/api/endpoints/maturity";

export function useGetMaturityFramework() {
  return useQuery({
    queryKey: queryKeys.maturity.framework(),
    queryFn: getMaturityFramework,
    staleTime: Infinity,
  });
}
